import { useContext } from "react";

import { V2Button, cn, V2Heading, V2Skeleton } from "@stacklet/ui";
import DOMPurify from "dompurify";

import { HelpContext } from "app/contexts/HelpContext";
import { useHelpContent } from "app/hooks";

interface HelpProps {
  pageNames: string[];
}

export function Help({ pageNames }: HelpProps) {
  const helpContext = useContext(HelpContext);
  const [isLoading, helpContent] = useHelpContent(pageNames);

  if (helpContext.collapsed) {
    return null;
  }

  return (
    <div
      className={cn(
        "border-l border-outline-decorative flex-shrink-0 bg-background-primary fixed right-0 top-0 bottom-0 z-[1200] w-1/2 md:!w-[300px] 2xl:!w-[500px] overflow-auto",
      )}
      data-testid="help-drawer"
    >
      <div className="min-h-16 border-b border-outline-decorative" />
      <div className="flex items-center justify-between border-b border-outline-decorative p-lg">
        <V2Heading level={1}>Help</V2Heading>
        <V2Button
          className="text-legacy-navy-L30"
          onPress={helpContext.collapse}
          variant="link"
        >
          Close
        </V2Button>
      </div>
      {isLoading ? (
        <V2Skeleton height="100%" variant="rectangular" width="100%" />
      ) : (
        <div
          className="p-lg"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(helpContent) }}
        />
      )}
      <div className="min-h-16" />
    </div>
  );
}
